import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _isEmpty from 'lodash/isEmpty';
import invariant from 'invariant';
import warning from 'warning';

var Stores = function () {
  _createClass(Stores, [{
    key: "isInitialized",
    get: function get() {
      return this._isInitialized;
    }
  }]);

  function Stores() {
    var stores = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Stores);

    this._isInitialized = false;
    this._storesInstance = {};
    warning(!_isEmpty(stores), "Aucun store n'a \xE9t\xE9 pass\xE9 \xE0 `Stores`, cela siginifie qu'aucun store ne " + "sera inj\xE9ct\xE9, ce n'est surement pas le comportement d\xE9sir\xE9.");
    this._storesInstance = stores;
  }

  _createClass(Stores, [{
    key: "init",
    value: function init() {
      var _this = this;

      var initialStates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      invariant(!this._isInitialized, "[@insolus/stores] Les stores ont d\xE9j\xE0 \xE9t\xE9 initialis\xE9s.");
      this._isInitialized = true;
      var promises = [];
      Object.keys(this._storesInstance).forEach(function (key) {
        var instance = _this._storesInstance[key];
        var initialState = initialStates[key];

        if (typeof instance.init === 'function') {
          promises.push(instance.init(initialState));
        }
      });
      return Promise.all(promises);
    }
  }, {
    key: "get",
    value: function get() {
      invariant(this._isInitialized, "[@insolus/stores] Les stores doivent \xEAtre initialis\xE9s (`Stores.init()`) avant " + "de pouvoir \xEAtre r\xE9cup\xE9r\xE9s.");
      return this._storesInstance;
    }
  }]);

  return Stores;
}();

export default Stores;